const state = {
  listInbox: ['email'],
  contactList: [],
  selectedContacts: [],
  selectedContactsCC: [],
  selectedContactsCCO: [],
  contactsSelected: [],
  selectedEmail: [],
  email: null,
  emailLoading: false,
  sendEmail: null,
  pagination: {
    currentPage: 1,
  },
  emailCredentials: null,
  emailList: null,
  statistics: null,
  emailContact: null,
};

export default state;
